/** Canonical site origin for OG / share URLs (set per deploy in CI). */
export const SITE_ORIGIN =
  process.env.REACT_APP_SITE_ORIGIN || "https://qiktruck.co.za";

/** Per-page OG card, e.g. ogImageUrl("track-order") → …/og/track-order.jpg */
export function ogImageUrl(slug) {
  return `${SITE_ORIGIN}/og/${slug}.jpg`;
}

/** City location OG card, e.g. ogLocationImageUrl("johannesburg") */
export function ogLocationImageUrl(citySlug) {
  return `${SITE_ORIGIN}/og/locations/${citySlug}.jpg`;
}
